import './index.css';

export default {
  name: 'Askeleton',
  props: {
    visible: { type: Boolean, default: () => true },
    width: { type: String, default: () => '100%' },
    rows: { type: Number, default: () => 24 },
    animated: { type: Boolean, default: () => true },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    flex: { type: Boolean, default: () => true },
  },
  render() {
    const { margin = '0', padding = '0', background = 'rgba(0, 0, 0, 0)', ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return this.visible && (
      <div class={['a-skeleton', (this.flex ? 'flex' : null)]} style={{ margin, padding, background }}>
        <el-skeleton style={{ width: this.width }} rows={this.rows} animated={this.animated} {...{ attrs }}>
          {data.length > 0 && data.map((a, b) => (
            <template slot="template">
              <div key={b} class={['a-skeleton-item', (`a-skeleton-item-${b}`)]}>
                {a.render ? () => a.render(a) : (<el-skeleton-item variant={a.type} {...{ attrs: a }} />)}
              </div>
            </template>
          ))}
          {this.$slots.default}
        </el-skeleton>
      </div>
    );
  }
}